// extracted by mini-css-extract-plugin
export var header = "Header-module--header--NXzL8";
export var headerInfo = "Header-module--headerInfo--7Owgn";
export var headerTitle = "Header-module--headerTitle--Ywj2d";
export var headerOverlay = "Header-module--headerOverlay--gZlLu";
export var showMobile = "Header-module--showMobile--hI7+z";
export var showDesktop = "Header-module--showDesktop--VV81J";